import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=08f45eca"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Sinister/Filters/Filter.vue
// module id = 1498
// module chunks = 31